import { createApp } from 'vue'
import router from './router'
import 'bootstrap/dist/css/bootstrap.min.css'
import 'jquery/src/jquery.js'
import 'bootstrap/dist/js/bootstrap.min.js'
import './assets/main.css'
import App from './App.vue'
import './registerServiceWorker'




const laapp = createApp(App).use(router).mount('#app')


